import { Home } from "@mui/icons-material";
import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import AuthSessionGuard from "../commoncomponent/AuthSessionGuard";
import HowItWorks from "../../frontendpages/components/home/HowItWorks";
import About from "../../frontendpages/components/home/About";
import TermService from "../../frontendpages/components/Terms/TermService";
import lazyWithRetry from "./lazyWithRetry";
import Becometutor from "../../frontendpages/Becometutor";
import Createprofiletutor from "../../frontendpages/components/signupastutor/Createprofiletutor";

const Homepage = lazyWithRetry(() => import("../../frontendpages/Homepage"), "Homepage");
const Loginpage = lazyWithRetry(() => import("../../frontendpages/Loginpage"), "Loginpage");
const Signupstudent = lazyWithRetry(() => import("../../frontendpages/Signupstudent"), "Signupstudent");
const Createprofilestudent = lazyWithRetry(
  () =>
    import("../../frontendpages/components/signupasstudent/Createprofilestudent"),
  "Createprofilestudent",
);
const Resetemail = lazyWithRetry(
  () => import("../../frontendpages/components/Loginstudent/Resetemail"),
  "Resetemail",
);
const Resetpassword = lazyWithRetry(
  () => import("../../frontendpages/components/Loginstudent/Resetpassword"),
  "Resetpassword",
);
const AdminHomepage = lazyWithRetry(() => import("../../adminpages/AdminHomepage"), "AdminHomepage");
const PrivateRoute = lazyWithRetry(() => import("./PrivateRoute"), "PrivateRoute");
const AuthRoute = lazyWithRetry(() => import("./AuthRoute"), "AuthRoute");
const Emailverification = lazyWithRetry(
  () =>
    import("../../frontendpages/components/signupasstudent/Emailverification"),
  "Emailverification",
);
const StudentRouter = lazyWithRetry(() => import("./StudentRouter"), "StudentRouter");
const TutorHomepage = lazyWithRetry(() => import("../../tutorpages/TutorHomepage"), "TutorHomepage");
const ContactUs = lazyWithRetry(() => import("../../studentpages/profile/ContactUs"), "ContactUs");
const AdminRouter = lazyWithRetry(() => import("./AdminRouter"), "AdminRouter");
const SearchTutor = lazyWithRetry(
  () => import("../../studentpages/searchtutor/SearchTutor"),
  "SearchTutor",
);
const ViewTutor = lazyWithRetry(
  () => import("../../studentpages/searchtutor/ViewTutor"),
  "ViewTutor",
);
const Signupasinstitute = lazyWithRetry(
  () =>
    import("../../frontendpages/components/signupinstitute/Signupasinstitute"),
  "Signupasinstitute",
);
const OpsRouter = lazyWithRetry(() => import("./OpsRouter"), "OpsRouter");
const OpsHomepage = lazyWithRetry(() => import("../../opspages/OpsHomepage"), "OpsHomepage");
const TutorRouter = lazyWithRetry(() => import("./TutorRouter"), "TutorRouter");
const RedirectIfLoggedIn = lazyWithRetry(() => import("./RedirectIfLoggedIn"), "RedirectIfLoggedIn");
const TutorSubscription = lazyWithRetry(
  () => import("../../tutorpages/subscription/TutorSubscription"),
  "TutorSubscription",
);
const InstitutionRouter = lazyWithRetry(() => import("./InstitutionRouter"), "InstitutionRouter");
const InstitutionHomepage = lazyWithRetry(
  () => import("../../institutionpages/InstitutionHomepage"),
  "InstitutionHomepage",
);
const CreateProfileInstitution = lazyWithRetry(
  () =>
    import("../../frontendpages/components/signupinstitute/CreateProfileInstitution"),
  "CreateProfileInstitution",
);
const InstitutionSubscription = lazyWithRetry(
  () => import("../../institutionpages/subscription/InstitutionSubscription"),
  "InstitutionSubscription",
);
const CoordinatorHomepage = lazyWithRetry(
  () => import("../../coordinatorpages/CoordinatorHomepage"),
  "CoordinatorHomepage",
);
const CoordinatorRouter = lazyWithRetry(
  () => import("./CoordinatorRouter"),
  "CoordinatorRouter",
);
const FAQSection = lazyWithRetry(() => import("../../frontendpages/FAQSection"), "FAQSection");
const PlanPricing = lazyWithRetry(() => import("../../frontendpages/PlanPricing"), "PlanPricing");

const AppRouter = () => (
  <Router>
    <ScrollToTop />
    <AuthSessionGuard />
    <Suspense fallback={null}>
      <Routes>
        {/* Frontend Router */}
        <Route
          path="/"
          element={
            <RedirectIfLoggedIn>
              <Homepage />
            </RedirectIfLoggedIn>
          }
        />
        <Route
          path="/home"
          element={
            <RedirectIfLoggedIn>
              <Homepage />
            </RedirectIfLoggedIn>
          }
        />
        <Route
          path="/signup-as-student"
          element={
            <RedirectIfLoggedIn>
              <Signupstudent />
            </RedirectIfLoggedIn>
          }
        />
        <Route path="/emailverification" element={<Emailverification />} />
        <Route
          path="/create-profile-student"
          element={<Createprofilestudent />}
        />
        <Route path="/create-profile-tutor" element={<Createprofiletutor />} />
        <Route path="/login" element={<AuthRoute component={Loginpage} />} />
        {/* <Route path="/login" element={<Loginpage />} /> */}
        <Route
          path="/resetpassword"
          element={
            <RedirectIfLoggedIn>
              <Resetemail />
            </RedirectIfLoggedIn>
          }
        />
        <Route
          path="/changepassword"
          element={
            <RedirectIfLoggedIn>
              <Resetpassword />
            </RedirectIfLoggedIn>
          }
        />
        <Route
          path="/createpassword"
          element={
            <RedirectIfLoggedIn>
              <Resetpassword />
            </RedirectIfLoggedIn>
          }
        />
        <Route
          path="/signup-as-tutor"
          element={
            <RedirectIfLoggedIn>
              <Becometutor />
            </RedirectIfLoggedIn>
          }
        />
        <Route path="/create-profile-tutor" element={<Createprofiletutor />} />
        <Route
          path="/signup-as-institution"
          element={
            <RedirectIfLoggedIn>
              <Signupasinstitute />
            </RedirectIfLoggedIn>
          }
        />
        <Route
          path="/create-profile-institution"
          element={<CreateProfileInstitution />}
        />
        <Route path="/faq-page" element={<FAQSection />} />
        <Route
          path="/pricing"
          element={
            <RedirectIfLoggedIn>
              <PlanPricing />
            </RedirectIfLoggedIn>
          }
        />
        <Route
          path="/homepage"
          element={
            <PrivateRoute
              studentComponent={SearchTutor}
              adminComponent={AdminHomepage}
              tutorComponent={TutorHomepage}
              opsComponent={OpsHomepage}
              institutionComponent={InstitutionHomepage}
              coordinatorComponent={CoordinatorHomepage}
            />
          }
        />
        {/* Footer Routes */}
        <Route>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/HowItWorks" element={<HowItWorks />} />
          <Route path="/terms" element={<TermService />} />
        </Route>

        {/* Student dashboard Router */}
        <Route path="/student/*" element={<StudentRouter />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/search-tutor" element={<SearchTutor publicMode />} />
        <Route path="/view-tutor/:tutorId" element={<ViewTutor publicMode />} />

        {/* Admin dashboard Router */}
        <Route path="/admin/*" element={<AdminRouter />} />

        {/* Tutor dashboard Router */}
        <Route path="/tutor/*" element={<TutorRouter />} />
        <Route path="/subscription" element={<TutorSubscription />} />

        {/* Ops dashboard Router */}
        <Route path="/ops/*" element={<OpsRouter />} />

        {/* Institution dashboard Router */}
        <Route path="/institution/*" element={<InstitutionRouter />} />
        <Route path="/coordinator/*" element={<CoordinatorRouter />} />
        <Route
          path="/institution-subscription"
          element={<InstitutionSubscription />}
        />
      </Routes>
    </Suspense>
  </Router>
);

export default AppRouter;
